import { render } from "./legoChipExtend.vue?vue&type=template&id=2b6144be&scoped=true"
import script from "./legoChipExtend.vue?vue&type=script&lang=js"
export * from "./legoChipExtend.vue?vue&type=script&lang=js"

import "./legoChipExtend.vue?vue&type=style&index=0&id=2b6144be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6144be"],['__file',"src/components/lego/extend/legoChipExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b6144be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b6144be', __exports__)) {
    api.reload('2b6144be', __exports__)
  }
  
  module.hot.accept("./legoChipExtend.vue?vue&type=template&id=2b6144be&scoped=true", () => {
    api.rerender('2b6144be', render)
  })

}


export default __exports__